module.exports = __webpack_public_path__ + "media/images/whatsapp-8c19eee70119db32e09db60e54491473.svg";